import { createSelector } from 'reselect';
import { find, flow } from 'lodash/fp';

import { userIsVolunteer } from './utils';

export const userSelector = state => state.users;
export const selectUrlUserId = props => props.match.params.userId;

export const selectCurrentUser = createSelector(
  [
    userSelector,
  ],
  users => flow(
    find({ current: true }),
  )(users),
);

export const makeSelectUser = ({ userIdSelector }) => createSelector(
  [
    userSelector,
    userIdSelector,
  ],
  (users, userId) => userId === 'current'
    ? flow(
      find({ current: true }),
    )(users)
    : users[userId],
);

export const selectUrlUser = makeSelectUser({
  userIdSelector: (state, props) => {
    const urlUserId = selectUrlUserId(props);
    if (urlUserId === 'current') {
      const currentUser = selectCurrentUser(state, props);
      return currentUser && currentUser.id;
    }
    return urlUserId;
  },
});

export const selectSelectedUser = createSelector(
  [
    userSelector,
  ],
  users => flow(
    find({ selected: true }),
  )(users),
);

export const selectedUserHasFeedbackEnabled = createSelector(
  [
    selectSelectedUser,
  ],
  selectedUser => selectedUser.feedbackReceivement || false,
);

export const selectCurrentUserIsAnonymous = createSelector(
  [
    selectCurrentUser,
  ],
  currentUser => currentUser.userType === 'anonymous',
);

export const selectCurrentUserSelected = createSelector(
  [
    selectCurrentUser,
    selectSelectedUser,
  ],
  (currentUser, selectedUser) => currentUser.id === selectedUser.id,
);

export const selectedUserCanReceiveFeedback = createSelector(
  [
    selectCurrentUserSelected,
    selectCurrentUser,
    selectSelectedUser,
  ],
  (currentUserSelected, currentUser, selectedUser) => (
    !currentUserSelected &&
    userIsVolunteer(currentUser) &&
    selectedUser.feedbackReceivement
  ),
);

export const selectCurrentUserIsEducator = createSelector(
  [
    selectCurrentUser,
  ],
  currentUser => currentUser.userType === 'educator',
);

export const selectCurrentUserIsStudent = createSelector(
  [
    selectCurrentUser,
  ],
  currentUser => currentUser.userType === 'student',
);

export const selectCurrentUserIsProfessional = createSelector(
  [
    selectCurrentUser,
  ],
  currentUser => currentUser.userType === 'professional',
);
